export default "__VITE_ASSET__19efd355__"